import {OpaqueToken} from "@angular/core";

export const SELFBITS_CONFIG = new OpaqueToken('SelfbitsConfig');
